module.exports = __webpack_public_path__ + "assets/share_tw.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/share_tw.png
 ** module id = 148
 ** module chunks = 1
 **/